import EntityTimestamp from "../../entities/entityTimestamp";

/**
 * EntityTimestamp actions
 *
 * Call order:
 *
 * ENTITYTIMESTAMP_SAVE_QUEUE:	adds the item to the save queue
 * --> ENTITYTIMESTAMP_SAVE:	modifies the state
 * --> ENTITYTIMESTAMP_SAVE_SUCCESS: if all went well
 * --> ENTITYTIMESTAMP_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail ENTITYTIMESTAMP_SAVE_QUEUE is during the call to ENTITYTIMESTAMP_SAVE,
 * as adding an item to the queue should never fail.
 */

export const ENTITYTIMESTAMP_FETCH_ONE_QUEUE: any = 'ENTITYTIMESTAMP_FETCH_ONE_QUEUE';
export const ENTITYTIMESTAMP_FETCH_SUCCESS: any = 'ENTITYTIMESTAMP_FETCH_SUCCESS';
export const ENTITYTIMESTAMP_FETCH_FAILURE: any = 'ENTITYTIMESTAMP_FETCH_FAILURE';
export const ENTITYTIMESTAMP_FETCH_ONE_SUCCESS: any = 'ENTITYTIMESTAMP_FETCH_ONE_SUCCESS';
export const ENTITYTIMESTAMP_FETCH_ONE_FAILURE: any = 'ENTITYTIMESTAMP_FETCH_ONE_FAILURE';

export const ENTITYTIMESTAMP_SAVE: any = 'ENTITYTIMESTAMP_SAVE';
export const ENTITYTIMESTAMP_SAVE_QUEUE: any = 'ENTITYTIMESTAMP_SAVE_QUEUE';
export const ENTITYTIMESTAMP_SAVE_SUCCESS: any = 'ENTITYTIMESTAMP_SAVE_SUCCESS';
export const ENTITYTIMESTAMP_SAVE_FAILURE: any = 'ENTITYTIMESTAMP_SAVE_FAILURE';

export const ENTITYTIMESTAMP_SAVE_MANY: any = 'ENTITYTIMESTAMP_SAVE_MANY';
export const ENTITYTIMESTAMP_SAVE_MANY_QUEUE: any = 'ENTITYTIMESTAMP_SAVE_MANY_QUEUE';
export const ENTITYTIMESTAMP_SAVE_MANY_SUCCESS: any = 'ENTITYTIMESTAMP_SAVE_MANY_SUCCESS';
export const ENTITYTIMESTAMP_SAVE_MANY_FAILURE: any = 'ENTITYTIMESTAMP_SAVE_MANY_FAILURE';

export const ENTITYTIMESTAMP_REMOVE: any = 'ENTITYTIMESTAMP_REMOVE';
export const ENTITYTIMESTAMP_REMOVE_QUEUE: any = 'ENTITYTIMESTAMP_REMOVE_QUEUE';
export const ENTITYTIMESTAMP_REMOVE_SUCCESS: any = 'ENTITYTIMESTAMP_REMOVE_SUCCESS';
export const ENTITYTIMESTAMP_REMOVE_FAILURE: any = 'ENTITYTIMESTAMP_REMOVE_FAILURE';

export const ENTITYTIMESTAMP_RESTORE: any = 'ENTITYTIMESTAMP_RESTORE';
export const ENTITYTIMESTAMP_RESTORE_QUEUE: any = 'ENTITYTIMESTAMP_RESTORE_QUEUE';
export const ENTITYTIMESTAMP_RESTORE_SUCCESS: any = 'ENTITYTIMESTAMP_RESTORE_SUCCESS';
export const ENTITYTIMESTAMP_RESTORE_FAILURE: any = 'ENTITYTIMESTAMP_RESTORE_FAILURE';

export const ENTITYTIMESTAMP_RESTORE_MANY: any = 'ENTITYTIMESTAMP_RESTORE_MANY';
export const ENTITYTIMESTAMP_REMOVE_MANY: any = 'ENTITYTIMESTAMP_REMOVE_MANY';

/* Fetch actions */
export const fetchEntityTimestampSuccess = (entityTimestamps: EntityTimestamp[], partial: boolean, lastFetch: number) => ({type: ENTITYTIMESTAMP_FETCH_SUCCESS, entityTimestamps, partial, lastFetch});
export const fetchEntityTimestampFailure = (err: any) => {
		console.error('EntityTimestampAction: fetchEntityTimestampFailure', err);
		return {type: ENTITYTIMESTAMP_FETCH_FAILURE, err};
};
export const fetchOneEntityTimestampQueue = (entityTimestampId: string) => ({type: ENTITYTIMESTAMP_FETCH_ONE_QUEUE, entityTimestampId});
export const fetchOneEntityTimestampSuccess = (entityTimestamp: EntityTimestamp) => ({type: ENTITYTIMESTAMP_FETCH_ONE_SUCCESS, entityTimestamp});
export const fetchOneEntityTimestampFailure = (id: string, err: any) => {
		console.error('EntityTimestampAction: fetchOneEntityTimestampFailure', err);
		return {type: ENTITYTIMESTAMP_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveEntityTimestamp = (entityTimestamp: EntityTimestamp) => {
    // console.debug('⮂ ENTITYTIMESTAMP_SAVE action', entityTimestamp?.id);
    return {type: ENTITYTIMESTAMP_SAVE, entityTimestamp};
}
export const saveEntityTimestampQueue = (entityTimestamp: EntityTimestamp, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ ENTITYTIMESTAMP_SAVE_QUEUE action', entityTimestamp?.id);
    return {type: ENTITYTIMESTAMP_SAVE_QUEUE, entityTimestamp, onQueued};
}
export const saveEntityTimestampSuccess = (entityTimestamp: EntityTimestamp) => {
    // console.debug('⮂ ENTITYTIMESTAMP_SAVE_SUCCESS action', entityTimestamp?.id);
    return {type: ENTITYTIMESTAMP_SAVE_SUCCESS, entityTimestamp};
}
export const saveEntityTimestampFailure = (entityTimestamp: EntityTimestamp, status: number, message: string) => {
    console.warn(`⮂ ENTITYTIMESTAMP_SAVE_FAILURE error saving entityTimestamp: HTTP ${status}: ${message}`, entityTimestamp?.id);
    return {type: ENTITYTIMESTAMP_SAVE_FAILURE, entityTimestamp, status, message};
};

/* SaveMany actions */
export const saveManyEntityTimestamps = (entityTimestamps: EntityTimestamp[]) => {
    // console.debug('⮂ ENTITYTIMESTAMP_SAVE_MANY action', entityTimestamps?.map(entityTimestamp => entityTimestamp?.id).join(','));
    return {type: ENTITYTIMESTAMP_SAVE_MANY, entityTimestamps};
}
export const saveManyEntityTimestampsQueue = (entityTimestamps: EntityTimestamp[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ ENTITYTIMESTAMP_SAVE_MANY_QUEUE action', entityTimestamps?.map(entityTimestamp => entityTimestamp.id).join(','));
    return {type: ENTITYTIMESTAMP_SAVE_MANY_QUEUE, entityTimestamps, onQueued};
}

export const saveManyEntityTimestampsSuccess = (entityTimestamps: EntityTimestamp[]) => {
    // console.debug('⮂ ENTITYTIMESTAMP_SAVE_MANY_SUCCESS action', entityTimestamps?.map(entityTimestamp => entityTimestamp.id).join(','));
    return {type: ENTITYTIMESTAMP_SAVE_MANY_SUCCESS, entityTimestamps};
}
export const saveManyEntityTimestampsFailure = (entityTimestamps: EntityTimestamp[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_ENTITYTIMESTAMPS_FAILURE Error saving entityTimestamps: HTTP ${status}: ${message}`, entityTimestamps?.map(entityTimestamp => entityTimestamp.id).join(','));
		return {type: ENTITYTIMESTAMP_SAVE_MANY_FAILURE, entityTimestamps, status, message};
};

/* Remove actions */
export const removeEntityTimestamp = (entityTimestamp: EntityTimestamp) => ({ type: ENTITYTIMESTAMP_REMOVE, entityTimestamp });
export const removeEntityTimestampQueue = (entityTimestamp: EntityTimestamp) => ({ type: ENTITYTIMESTAMP_REMOVE_QUEUE, entityTimestamp });
export const removeEntityTimestampSuccess = (entityTimestamp: EntityTimestamp) => ({ type: ENTITYTIMESTAMP_REMOVE_SUCCESS, entityTimestamp });
export const removeEntityTimestampFailure = (entityTimestamp: EntityTimestamp, status: number, message: string) => {
	console.error(`Redux: removeEntityTimestampFailure Error removing entityTimestamp: HTTP ${status}: ${message}`);
	return ({ type: ENTITYTIMESTAMP_REMOVE_FAILURE, entityTimestamp, status, message });
};

/* Restore actions */
export const restoreEntityTimestamp = (entityTimestamp: EntityTimestamp) => ({ type: ENTITYTIMESTAMP_RESTORE, entityTimestamp });
export const restoreEntityTimestampQueue = (entityTimestamp: EntityTimestamp) => ({ type: ENTITYTIMESTAMP_RESTORE_QUEUE, entityTimestamp });
export const restoreEntityTimestampSuccess = (entityTimestamp: EntityTimestamp) => ({ type: ENTITYTIMESTAMP_RESTORE_SUCCESS, entityTimestamp });
export const restoreEntityTimestampFailure = (entityTimestamp: EntityTimestamp, status: number, message: string) => {
	console.error(`Redux: restoreEntityTimestampFailure Error restoring entityTimestamp: HTTP ${status}: ${message}`);
	return ({ type: ENTITYTIMESTAMP_RESTORE_FAILURE, entityTimestamp, status, message });
};

/* RestoreMany actions */
export const restoreManyEntityTimestamps = (entityTimestamps: EntityTimestamp[]) => ({ type: ENTITYTIMESTAMP_RESTORE_MANY, entityTimestamps });

/* RemoveMany actions */
export const removeManyEntityTimestamps = (entityTimestamps: EntityTimestamp[]) => ({ type: ENTITYTIMESTAMP_REMOVE_MANY, entityTimestamps });